import { AccordionDetails } from "@material-ui/core";
import React from "react";

//styles
import styles from "./LAccordionDetails.module.scss";

/*
    Separate component in order to override styling
*/
const LAccordionDetails: React.FC = (props) => {
    return (
        <AccordionDetails
            classes={{
                root: styles["accordion-details-root"]
            }}>
            {props.children}
        </AccordionDetails>
    );
};

export default LAccordionDetails;
